import styled from 'styled-components';

export const FieldSet = styled.div`
  width: 231px;
`;

export const DatePicker = styled.div`
  width: 100%;

  .SingleDatePickerInput {
    position: relative;
  }

  .SingleDatePickerInput_calendarIcon {
    top: 10px;
    right: 10px;
    position: absolute;
  }

  .DateRangePicker {
    margin: 0;
  }

  .DateRangePicker,
  .SingleDatePicker {
    background: #3f4147;
  }
`;

export const Form = styled.div`
  width: 750px;
  display: flex;
  margin-bottom: 24px;
  justify-content: space-between;
`;


